import React, { Component } from "react";
import iconEmpty from "images/empty.svg";
class EmptyInternal extends Component {
    render() {
        return (
            <div className="empty-internal">
                <div className="title">应用名称</div>
                <div className="empty-content">
                    <img src={iconEmpty} width="100px" alt="empty" />
                    <span>应用还没有准备好…</span>
                </div>
            </div>
        )
    }
}

export default EmptyInternal